export function conversationAdMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      conversationAdId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateConversationAdId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateConversationAdId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function conversationAdMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, conversationAdId: json.result.objectId, adminMarkets: json.result.markets.map((item) => ({markets : item}))}
  };
}